import React from 'react'

const Contact = () => {
  return (
    <div>index</div>
  )
}

export default Contact